import React from 'react';
import { Chip, CircularProgress } from '@mui/material';

const STATUS_CONFIG = {
  draft: { label: 'Draft', color: 'default' },
  scraping: { label: 'Scraping', color: 'info', loading: true },
  generating: { label: 'Generating', color: 'info', loading: true },
  review: { label: 'Review', color: 'warning' },
  published: { label: 'Published (Pulse)', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
  archived: { label: 'Deleted', color: 'default', strikethrough: true },
};

function StatusBadge({ status }) {
  const config = STATUS_CONFIG[status] || { label: status || 'Unknown', color: 'default' };

  return (
    <Chip
      size="small"
      label={
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
          {config.loading && <CircularProgress size={12} color="inherit" />}
          {config.label}
        </span>
      }
      color={config.color}
      variant={status === 'archived' ? 'outlined' : 'filled'}
      sx={config.strikethrough ? { textDecoration: 'line-through' } : undefined}
    />
  );
}

export default StatusBadge;
